import { Scene } from "phaser";
import { GButton } from "../gameobjects/GButton";

export class ErrorPopScene extends Scene {

    constructor() {
        super("ErrorPopScene");
    }

    init(data) {
        console.log("ERROR data", data)
        this.errorMessage  = data
    
    }

    create() {


        this.cameras.main.setBackgroundColor('rgba(21, 21, 21, 0.85)');

         // Create a transparent input zone that covers the entire screen
         this.inputZone = this.add.zone(0, 0, this.scale.width, this.scale.height)
         .setOrigin(0)
         .setInteractive(); // Make it interactive to capture clicks

        this.graphics = this.add.graphics();

        this.graphics.fillStyle(0x212121, 1);

        this.graphics.fillRoundedRect(32,this.scale.height/2 - 343, 343*2 , 246 *2, 32);


        this.title = this.add.text(this.scale.width/2,this.scale.height/2 - 343 + 64, `INFORMATION`,  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(0.5);
        this.title.setFontStyle('700')


        this.title = this.add.text(this.scale.width/2, this.scale.height/2 -64,  this.errorMessage ,  
            { fontFamily: 'Oswald', fontSize: 32, 
                color: '#ffffff',
                align: 'center',
                wordWrap: { width:  343*2 - 128, useAdvancedWrap: true }
            }).setOrigin(0.5,1);



        const ButtonCancel = new GButton( this, this.scale.width/2, this.scale.height/2+ 52, {
            texturePack: "pack", 
            idleTexture: 'Button - Secondary - Default.png',
            clickedTexture: 'Button - Secondary - Clicked.png',
            disabledTexture: 'Button - Secondary - Disabled.png',
            nineslice: {},
            text: {
                value:'CANCEL',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            onClick: () => {
                
                this.scene.stop()
                
             }
        });

        ButtonCancel.setScale(0.75);

       
    }

    

}